import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  loadingBoxRankDescription: {
    height: 20,
    width: 130,
  },
  loadingBoxPreviousRankDescription: {
    height: 20,
    width: 100,
  },
  loadingBoxPromotedOnDate: {
    height: 20,
    width: 140,
  },
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemContainer: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
